<template>
  <div class="main device-page">
    <div class="main_r" ref="pageBody">
      <div class="page-top">
        <div class="title_line">设备列表</div>

        <div class="stats-bar">
          <div class="stat-card stat-total">
            <span class="stat-value">{{ deviceStats.total }}</span>
            <span class="stat-label">设备总数</span>
          </div>
          <div class="stat-card stat-online">
            <span class="stat-value">
              <i class="status-dot is-online"></i>{{ deviceStats.online }}
            </span>
            <span class="stat-label">在线 · {{ onlineRate }}%</span>
          </div>
          <div class="stat-card stat-offline">
            <span class="stat-value">
              <i class="status-dot is-offline"></i>{{ deviceStats.offline }}
            </span>
            <span class="stat-label">离线</span>
          </div>
          <div class="stat-card stat-locked">
            <span class="stat-value">{{ deviceStats.locked }}</span>
            <span class="stat-label">锁机</span>
          </div>
        </div>

        <div class="filter-strip">
          <div class="filter-strip__fields">
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">设备名称</label>
              <el-input v-model="queryData.deviceName" placeholder="输入名称" clearable size="small"></el-input>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">唯一编号</label>
              <el-input v-model="queryData.deviceSn" placeholder="输入编号" clearable size="small"></el-input>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">在线状态</label>
              <el-select v-model="queryData.isOnline" placeholder="全部" size="small">
                <el-option label="全部" :value="''"></el-option>
                <el-option label="在线" :value="1"></el-option>
                <el-option label="离线" :value="0"></el-option>
              </el-select>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">设备状态</label>
              <el-select v-model="queryData.deviceStatus" placeholder="全部" size="small">
                <el-option label="全部" value="0"></el-option>
                <el-option label="正常" value="1"></el-option>
                <el-option label="锁机" value="2"></el-option>
              </el-select>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">起始日期</label>
              <el-date-picker v-model="queryData.timeBegin" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="small"></el-date-picker>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">结束日期</label>
              <el-date-picker v-model="queryData.timeEnd" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="small"></el-date-picker>
            </div>
          </div>
          <div class="filter-strip__actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="clickQuery">查询</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickQueryReset">重置</el-button>
            <span class="filter-strip__sep"></span>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="clickdialogAdd">新增</el-button>
            <UploadExcel size="small" @change="changeUploadExcel"></UploadExcel>
          </div>
        </div>
      </div>

      <!-- 列表 -->
      <div class="table-section" ref="tableSection">
        <div class="table-container" :class="{ 'has-scroll': tableHasScroll }" ref="tableContainer">
          <el-table
            :data="dataList"
            class="device-table"
            :height="tableHeight"
            :header-cell-style="tableHeaderStyle"
            :cell-style="tableCellStyle"
            @sort-change="handleSortChange">
            <el-table-column type="index" label="序号" width="80" fixed="left" align="center" :index="tableIndexMethod"></el-table-column>
            <el-table-column prop="deviceName" label="设备名称" min-width="150" sortable="custom" show-overflow-tooltip></el-table-column>
            <el-table-column prop="deviceSn" label="识别" min-width="150" sortable="custom" show-overflow-tooltip></el-table-column>
            <el-table-column prop="isOnline" label="在线状态" min-width="120" sortable="custom" align="center">
              <template slot-scope="props">
                <span class="online-status" :class="props.row.isOnline == 1 ? 'is-online' : 'is-offline'">
                  <i class="status-dot"></i>{{ props.row.isOnline == 1 ? '在线' : '离线' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="deviceStatus" label="设备状态" min-width="120" sortable="custom" align="center">
              <template slot-scope="props">
                <el-tag :type="props.row.deviceStatus == 1 ? 'success' : 'danger'" size="small" effect="plain">{{ props.row.deviceStatus == 1 ? '正常' : '锁机' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="appVersion" label="软件版本" min-width="110" sortable="custom" show-overflow-tooltip class-name="col-mono"></el-table-column>
            <el-table-column prop="firmWare" label="固件版本" min-width="120" sortable="custom" show-overflow-tooltip class-name="col-mono"></el-table-column>
            <el-table-column prop="androidFirmware" label="安卓系统固件版本" min-width="180" sortable="custom" show-overflow-tooltip class-name="col-mono"></el-table-column>
            <el-table-column prop="province" label="位置" min-width="140" sortable="custom" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ formatLocation(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column prop="lastOnlineTime" label="最后上线时长" min-width="180" sortable="custom" show-overflow-tooltip class-name="col-mono"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="180" sortable="custom" show-overflow-tooltip class-name="col-mono"></el-table-column>
            <el-table-column prop="Operation" label="操作" width="140" fixed="right" align="center">
              <template slot-scope="scope">
                <div class="action-group">
                  <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-edit" @click="clickdialogEdit(scope.row)"></el-link>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                    <el-link :underline="false" type="danger" icon="el-icon-delete" @click="ClickDelete(scope.row)"></el-link>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="查看日志" placement="top" :enterable="false">
                    <el-link :underline="false" type="warning" icon="el-icon-document" @click="clickViewLog(scope.row)"></el-link>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="scope.row.deviceStatus == 2 ? '解锁' : '锁机'" placement="top" :enterable="false">
                    <el-link :underline="false" :type="scope.row.deviceStatus == 2 ? 'success' : 'danger'" :icon="scope.row.deviceStatus == 2 ? 'el-icon-unlock' : 'el-icon-lock'" @click="clickLockDevice(scope.row)"></el-link>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="page_size"
          layout="total, prev, pager, next, sizes, jumper"
          :total="dataListnum">
        </el-pagination>
      </div>
    </div>

    <!---------------------- 以下是弹框内容 ---------------------->
        <!-- 新增 -->
        <el-dialog title="添加" :visible.sync="dialogAdd" width="36%" class="newAdd">
          <div class="addUser_body">
            <el-form ref="userMsg" :model="addData" label-width="170px">
              <el-form-item label="设备名称" :required=true>
                <el-input v-model="addData.deviceName" placeholder="请输入设备名称"></el-input>
              </el-form-item>
              <el-form-item label="设备唯一编号" :required=true>
                <el-input v-model="addData.deviceSn" placeholder="请输入设备唯一编号"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="DeviceInsert()" >确定</el-button>
            <el-button @click="dialogAdd = false">取消</el-button>
          </div>
        </el-dialog>
        <!-- 新增 End -->

        <!-- 编辑信息 -->
        <el-dialog title="编辑信息" :visible.sync="dialogEdit" width="36%" class="newAdd">
          <div class="addUser_body">
            <el-form ref="editForm" :model="editData" :rules="editRules" label-width="170px">
              <el-form-item label="设备名称" prop="deviceName">
                <el-input v-model="editData.deviceName" placeholder="请输入设备名称"></el-input>
              </el-form-item>
              <el-form-item label="设备唯一编号" prop="deviceSn">
                <el-input v-model="editData.deviceSn" placeholder="请输入设备唯一编号"></el-input>
              </el-form-item>
              <el-form-item label="设备状态" prop="deviceStatus">
                <el-select v-model="editData.deviceStatus" placeholder="设备状态">
                  <el-option label="正常" value="1"></el-option>
                  <el-option label="锁机" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="软件版本">
                <el-input v-model="editData.appVersion" placeholder="软件版本" disabled></el-input>
              </el-form-item>
              <el-form-item label="固件版本号">
                <el-input v-model="editData.firmWare" placeholder="固件版本号" disabled></el-input>
              </el-form-item>
              <el-form-item label="安卓系统固件版本">
                <el-input v-model="editData.androidFirmware" placeholder="安卓系统固件版本" disabled></el-input>
              </el-form-item>
              <el-form-item label="位置">
                <el-input :value="(editData.country || '') + (editData.province || '') + (editData.city || '') + (editData.district || '')" placeholder="位置" disabled></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="DeviceUpdate()" >确定</el-button>
            <el-button @click="dialogEdit = false">取消</el-button>
          </div>
        </el-dialog>
        <!-- 编辑信息 End -->

        <!-- 设备日志 -->
        <el-dialog :title="'设备日志 - ' + logDeviceSn" :visible.sync="dialogLog" width="70%" class="logDialog" @close="closeLogDialog" :close-on-click-modal="false">
          <div class="log-container">
            <!-- 日志说明：仅解释各标记的客观含义，供双方基于同一份事实排查-->
            <el-alert class="log-legend" type="info" :closable="true" show-icon>
              <div slot="title" class="log-legend-text">
                日志说明：<b>TX</b>=App下发指令；<b>RX</b>=收到回包(<b>checksum</b>=CRC校验结果)；<b>CMD_ACK_MATCH</b>=收到匹配响应(<b>rtt</b>=往返耗时)；
                级别：<b>INFO</b>=正常收发；<b>WARN</b>=需关注(重试/响应不匹配/帧间脏字节)；<b>ERROR</b>=通信异常(CRC校验失败/组帧失败/命令超时)；
                每行最前为线程号(adb logcat)；需要字节级排查粘包/半包时，勾选<b>Debug</b> 查看 RX_CHUNK 原始分片。
              </div>
            </el-alert>
            <!-- 区块1: 过滤条件 -->
            <div class="log-filters">
              <span style="margin-right: 15px; color: #606266; font-size: 14px;">日志级别：</span>
              <el-checkbox-group v-model="logFilter.levels" size="small">
                <el-checkbox label="d">Debug</el-checkbox>
                <el-checkbox label="i">Info</el-checkbox>
                <el-checkbox label="w">Warn</el-checkbox>
                <el-checkbox label="e">Error</el-checkbox>
              </el-checkbox-group>
              <span style="margin-left: 30px; margin-right: 15px; color: #606266; font-size: 14px;">日志类型：</span>
              <el-checkbox-group v-model="logFilter.types" size="small">
                <el-checkbox label="app">应用</el-checkbox>
                <el-checkbox label="serial">串口</el-checkbox>
              </el-checkbox-group>
              <span style="margin-left: 30px; margin-right: 15px; color: #606266; font-size: 14px;">时间排序：</span>
              <el-radio-group v-model="logSortOrder" size="small" @change="onLogSortOrderChange">
                <el-radio label="asc">升序</el-radio>
                <el-radio label="desc">降序</el-radio>
              </el-radio-group>
            </div>
            <!-- 区块2: 操作栏 -->
            <div class="log-actions">
              <div class="log-actions-left">
                <span class="action-label">订阅时长：</span>
                <el-input-number v-model="logFilter.duration" :min="60" :max="1800" :step="60" size="small" style="width: 140px;"></el-input-number>
                <span class="action-unit">条</span>
                <el-button type="primary" size="small" @click="logSubscribe" :loading="logSubscribing">
                  {{ logSubscribed ? '重新订阅' : '开始订阅' }}
                </el-button>
                <el-button type="warning" size="small" @click="logUnsubscribe" :disabled="!logSubscribed">取消订阅</el-button>
                <el-tag :type="logSubscribed ? 'success' : 'info'" size="small" style="margin-left: 10px;">
                  {{ logSubscribed ? '订阅中(' + formatCountdown(logCountdown) + ')' : '未订阅' }}
                </el-tag>
              </div>
              <div class="log-actions-divider"></div>
              <div class="log-actions-right">
                <span class="action-label">拉取条数：</span>
                <el-input-number v-model="logFilter.limit" :min="10" :max="500" :step="10" size="small" style="width: 120px;"></el-input-number>
                <span class="action-unit">条</span>
                <el-button size="small" @click="logFetch" :loading="logFetching" :disabled="logFetching" plain>拉取历史</el-button>
                <el-button size="small" @click="logClear" plain>清空</el-button>
              </div>
            </div>
            <!-- 区块3: 日志显示区 -->
            <div class="log-display" ref="logDisplay">
              <div v-if="logEntries.length === 0" class="log-empty">暂无日志数据</div>
              <div v-for="(entry, index) in logEntries" :key="index" class="log-entry" :class="'log-level-' + entry.level">
                <span class="log-time">{{ formatLogTime(entry.ts) }}</span>
                <span class="log-thread" v-if="entry.thread">{{ entry.thread }}</span>
                <span class="log-level-tag" :class="'tag-' + entry.level">{{ levelLabel(entry.level) }}</span>
                <span class="log-type-tag">{{ entry.type }}</span>
                <span class="log-tag">[ {{ entry.tag }} ]</span>
                <span class="log-msg">{{ entry.msg }}</span>
              </div>
            </div>
          </div>
        </el-dialog>
        <!-- 设备日志 End -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import DeviceBindblesn from '@/componentsSubVue/DeviceBindblesn.vue'
import UploadExcel from '../components/UploadExcel.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    DeviceBindblesn,
    UploadExcel
  },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        deviceName: '',
        deviceSn: '',
        deviceStatus: '0',
        isOnline: '',
        timeBegin: '',
        timeEnd: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      deviceStats: {
        total: 0,
        online: 0,
        offline: 0,
        locked: 0
      },
      tableHasScroll: false,
      tableHeight: 480,
      page_no: 1,
      page_size: 10,
      sortField: '',
      sortOrder: '',
      // 新增
      dialogAdd: false,
      addData: {
        deviceName: '0',
        deviceSn: ''
      },
      // 编辑
      dialogEdit: false,
      editData: {
        id: '',
        deviceName: '',
        deviceSn: '',
        deviceStatus: '',
        appVersion: '',
        country: '',
        deviceType: '',
        firmWare: '',
        androidFirmware: '',
        province: '',
        city: '',
        district: ''
      },
      editRules: {
        deviceName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        deviceSn: [{ required: true, message: '请输入设备唯一编号', trigger: 'blur' }],
        deviceStatus: [{ required: true, message: '请选择设备状态', trigger: 'change' }]
      },
      // 锁机
      lockLoading: false,
      // 设备日志
      dialogLog: false,
      logDeviceSn: '',
      logEntries: [],
      logSubscribing: false,
      logSubscribed: false,
      logFetching: false,
      logFetchTimer: null,
      logEventSource: null,
      logFilter: {
        levels: ['i', 'w', 'e'],
        types: ['app', 'serial'],
        duration: 300,
        limit: 100
      },
      logCountdown: 0,
      logCountdownTimer: null,
      logSortOrder: 'asc'
    }
  },
  computed: {
    onlineRate () {
      if (!this.deviceStats.total) return 0
      return Math.round(this.deviceStats.online / this.deviceStats.total * 100)
    }
  },
  mounted () {
    this.DeviceList()
    this.DeviceNum()
    window.addEventListener('resize', this.onWindowResize)
    this._mainEl = this.$el.closest('.el-main')
    if (this._mainEl) {
      this._mainEl.classList.add('el-main--device-page')
    }
    this.$nextTick(this.initTableResizeObserver)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)
    this.destroyTableResizeObserver()
    if (this._mainEl) {
      this._mainEl.classList.remove('el-main--device-page')
    }
  },
  methods: {
    tableHeaderStyle () {
      return { textAlign: 'center', background: 'var(--aptus-surface-muted)', color: 'var(--aptus-text-secondary)', fontWeight: '600' }
    },
    tableCellStyle ({ column }) {
      if (column.type === 'index' || column.property === 'Operation' || column.property === 'isOnline' || column.property === 'deviceStatus') {
        return { textAlign: 'center' }
      }
      return { textAlign: 'left' }
    },
    formatLocation (row) {
      var location = (row.country || '') + (row.province || '') + (row.city || '') + (row.district || '')
      return location || '-'
    },
    buildStatsQueryParams (overrides) {
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceName = this.queryData.deviceName
      data.deviceSn = this.queryData.deviceSn
      data.timeBegin = this.queryData.timeBegin
      data.timeEnd = this.queryData.timeEnd
      data.deviceStatus = overrides.deviceStatus !== undefined ? overrides.deviceStatus : '0'
      data.isOnline = overrides.isOnline !== undefined ? overrides.isOnline : ''
      data.sign = Vue.prototype.FunGetSign(data)
      return data
    },
    fetchDeviceNumByFilter (overrides) {
      var data = this.buildStatsQueryParams(overrides)
      return axios.post(Vue.prototype.global.Url_DeviceNum, Qs.stringify(data))
        .then(function (response) {
          return response.data.code === 1 ? response.data.data : 0
        })
        .catch(function () {
          return 0
        })
    },
    fetchDeviceStats () {
      var that = this
      Promise.all([
        that.fetchDeviceNumByFilter({}),
        that.fetchDeviceNumByFilter({ isOnline: 1 }),
        that.fetchDeviceNumByFilter({ isOnline: 0 }),
        that.fetchDeviceNumByFilter({ deviceStatus: '2' })
      ]).then(function (results) {
        that.deviceStats = {
          total: results[0],
          online: results[1],
          offline: results[2],
          locked: results[3]
        }
      })
    },
    checkTableScroll () {
      var that = this
      this.$nextTick(function () {
        var el = that.$refs.tableContainer
        if (!el) return
        var bodyWrapper = el.querySelector('.el-table__body-wrapper')
        var target = bodyWrapper || el
        that.tableHasScroll = target.scrollWidth > target.clientWidth + 2
      })
    },
    calcTableHeight () {
      var that = this
      this.$nextTick(function () {
        var container = that.$refs.tableContainer
        if (!container) return
        var height = container.clientHeight
        if (height > 0) {
          that.tableHeight = Math.max(240, Math.floor(height))
        }
        that.checkTableScroll()
      })
    },
    initTableResizeObserver () {
      var that = this
      this.calcTableHeight()
      if (typeof ResizeObserver === 'undefined') return
      this.tableResizeObserver = new ResizeObserver(function () {
        that.calcTableHeight()
      })
      if (this.$refs.tableContainer) {
        this.tableResizeObserver.observe(this.$refs.tableContainer)
      }
    },
    destroyTableResizeObserver () {
      if (this.tableResizeObserver) {
        this.tableResizeObserver.disconnect()
        this.tableResizeObserver = null
      }
    },
    onWindowResize () {
      this.calcTableHeight()
    },
    BackToFirst (val) {
      this.activeName = 'first'
    },
    gotoDeviceBindblesn(row){
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    handleSizeChange (val) {
      this.page_size = val
      this.DeviceList()
      this.DeviceNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.DeviceList()
      this.DeviceNum()
    },
    tableIndexMethod (index) {
      const seq = (this.page_no - 1) * this.page_size + index + 1
      if (this.sortOrder === 'asc') {
        return seq
      }
      return this.dataListnum - seq + 1
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.DeviceList()
      this.DeviceNum()
    },
    clickQuery () {
      this.page_no = 1
      this.DeviceList()
      this.DeviceNum()
    },
    clickQueryReset () {
      this.queryData.deviceName = ''
      this.queryData.deviceSn = ''
      this.queryData.deviceStatus = '0'
      this.queryData.isOnline = ''
      this.queryData.timeBegin = ''
      this.queryData.timeEnd = ''
      this.clickQuery()
    },
    clickdialogAdd () {
      this.dialogAdd = true
      this.addData.deviceName = ''
      this.addData.deviceSn = ''
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.deviceName = row.deviceName
      this.editData.deviceSn = row.deviceSn
      this.editData.deviceStatus = row.deviceStatus.toString()
      this.editData.country = row.country
      this.editData.appVersion = row.appVersion
      this.editData.deviceType = row.deviceType
      this.editData.firmWare = row.firmWare
      this.editData.androidFirmware = row.androidFirmware
      this.editData.province = row.province
      this.editData.city = row.city
      this.editData.district = row.district
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate()
      })
    },
    ClickDelete (row) {
      var that = this
      this.$deleteConfirm('确定删除？').then(function () {
        that.DeviceDelete(row.id)
      })
    },
    changeUploadExcel (response) {
      console.log(response)
      Vue.prototype.FunRemindOnlyError(response)
      if (response.code === 1) {
        Vue.prototype.FunRemindAllways(response.data)
        this.DeviceList()
        this.DeviceNum()
      }
    },
    DeviceList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceName = that.queryData.deviceName
      data.deviceSn = that.queryData.deviceSn
      data.deviceStatus = that.queryData.deviceStatus
      data.isOnline = that.queryData.isOnline
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
          that.calcTableHeight()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    DeviceNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceName = that.queryData.deviceName
      data.deviceSn = that.queryData.deviceSn
      data.deviceStatus = that.queryData.deviceStatus
      data.isOnline = that.queryData.isOnline
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
          that.fetchDeviceStats()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    DeviceInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceName = that.addData.deviceName
      data.deviceSn = that.addData.deviceSn
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceInsert, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.DeviceList()
            that.DeviceNum()
            that.dialogAdd = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAdd = false
        })
    },
    DeviceUpdate: function () {
      this.$refs.editForm.validate((valid) => {
        if (!valid) return
        var that = this
        var data = Vue.prototype.FunGetBaseSignData()
        data.id = that.editData.id
        data.deviceName = that.editData.deviceName
        data.deviceSn = that.editData.deviceSn
        data.deviceStatus = that.editData.deviceStatus
        data.deviceType = that.editData.deviceType
        // 以下字段可能为null，只在有实际值时才加入参数
        if (that.editData.country) data.country = that.editData.country
        if (that.editData.appVersion) data.appVersion = that.editData.appVersion
        if (that.editData.firmWare) data.firmWare = that.editData.firmWare
        if (that.editData.province) data.province = that.editData.province
        if (that.editData.city) data.city = that.editData.city
        if (that.editData.district) data.district = that.editData.district
        data.sign = Vue.prototype.FunGetSign(data)
        axios.post(Vue.prototype.global.Url_DeviceUpdate, Qs.stringify(data))
          .then(function (response) {
            that.dialogEdit = false
            Vue.prototype.FunRemindOnlyError(response.data)
            if (response.data.code === 1) {
              that.DeviceList()
              that.DeviceNum()
            }
          })
          .catch(function (error) {
            console.log(error)
            that.dialogEdit = false
          })
      })
    },
    DeviceDelete: function (id) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.DeviceList()
            that.DeviceNum()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 锁机/解锁
    clickLockDevice (row) {
      var action = row.deviceStatus == 2 ? 'unlock' : 'lock'
      var actionText = action === 'lock' ? '锁定' : '解锁'
      var that = this
      this.$deleteConfirm('确定' + actionText + '该设备？', '操作确认').then(function () {
        var data = Vue.prototype.FunGetBaseSignData()
        data.deviceSn = row.deviceSn
        data.action = action
        data.sign = Vue.prototype.FunGetSign(data)
        axios.post(Vue.prototype.global.Url_DeviceLock, Qs.stringify(data))
          .then(function (response) {
            Vue.prototype.FunRemindOnlyError(response.data)
            if (response.data.code === 1) {
              that.$message.success(actionText + '指令已发送')
              that.DeviceList()
              that.DeviceNum()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }).catch(function () {})
    },
    // 打开日志对话框
    clickViewLog (row) {
      this.logDeviceSn = row.deviceSn
      this.logEntries = []
      this.logSubscribed = false
      this.logSortOrder = 'asc'
      this.dialogLog = true
      this.connectLogStream()
    },
    // 连接 SSE 日志流
    connectLogStream () {
      if (this.logEventSource) {
        this.logEventSource.close()
      }
      var url = Vue.prototype.global.Url_DeviceLogStream + this.logDeviceSn
      this.logEventSource = new EventSource(url)

      this.logEventSource.addEventListener('log_data', (event) => {
        var logs = JSON.parse(event.data)
        this.logEntries = this.logEntries.concat(logs)
        this.sortLogEntriesByTime()
        this.trimLogEntries()
        this.$nextTick(() => {
          this.scrollLogToEdge()
        })
      })

      this.logEventSource.addEventListener('subscribe_ack', (event) => {
        var ack = JSON.parse(event.data)
        if (ack.success) {
          this.logSubscribed = true
          this.logSubscribing = false
          this.startLogCountdown(ack.expiresIn)
          this.$message.success('订阅成功，时长 ' + ack.expiresIn + ' 秒')
        } else {
          this.logSubscribing = false
          this.$message.error('订阅失败')
        }
      })

      this.logEventSource.addEventListener('fetch_result', (event) => {
        var result = JSON.parse(event.data)
        // 清除超时计时器
        if (this.logFetchTimer) {
          clearTimeout(this.logFetchTimer)
          this.logFetchTimer = null
        }
        // 历史日志与现有日志合并后统一按时间升序排列（最旧在上、最新在下），不再反转
        var logs = result.logs || []
        this.logEntries = logs.concat(this.logEntries)
        this.sortLogEntriesByTime()
        this.trimLogEntries()
        this.logFetching = false
        this.$message.success('拉取了' + logs.length + ' 条历史日志（缓冲区总计 ' + result.total + ' 条）')
        this.$nextTick(() => {
          this.scrollLogToEdge()
        })
      })

      this.logEventSource.addEventListener('lock_ack', (event) => {
        var ack = JSON.parse(event.data)
        if (ack.success) {
          this.$message.success('设备 ' + ack.deviceSn + ' 操作已确认')
        } else {
          this.$message.error('设备 ' + ack.deviceSn + ' 操作执行失败')
        }
        this.DeviceList()
        this.DeviceNum()
      })

      this.logEventSource.onerror = () => {
        console.log('SSE 连接错误')
      }
    },
    // 订阅日志
    logSubscribe () {
      this.logSubscribing = true
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceSn = that.logDeviceSn
      data.levels = that.logFilter.levels.join(',')
      data.types = that.logFilter.types.join(',')
      data.duration = that.logFilter.duration
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceLogSubscribe, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code !== 1) {
            that.logSubscribing = false
            Vue.prototype.FunRemindOnlyError(response.data)
          }
          // 成功时由 SSE subscribe_ack 事件处理
        })
        .catch(function (error) {
          console.log(error)
          that.logSubscribing = false
        })
    },
    // 取消订阅
    logUnsubscribe () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceSn = that.logDeviceSn
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceLogUnsubscribe, Qs.stringify(data))
        .then(function (response) {
          that.logSubscribed = false
          that.stopLogCountdown()
          Vue.prototype.FunRemindOnlyError(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 拉取历史日志
    logFetch () {
      if (this.logFetching) return
      if (this.logFetchTimer) {
        clearTimeout(this.logFetchTimer)
        this.logFetchTimer = null
      }
      this.logFetching = true
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceSn = that.logDeviceSn
      data.levels = that.logFilter.levels.join(',')
      data.types = that.logFilter.types.join(',')
      data.limit = that.logFilter.limit
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceLogFetch, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.$message.info('日志拉取指令已发送，等待设备响应...')
            // logFetching 保持 true，等 SSE fetch_result 事件来重置
            that.logFetchTimer = setTimeout(function () {
              if (that.logFetching) {
                that.logFetching = false
                that.$message.warning('日志拉取超时，设备未响应')
              }
            }, 120000)
          } else {
            that.$message.error(response.data.msg || '发送日志拉取指令失败')
            that.logFetching = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.$message.error('请求失败')
          that.logFetching = false
        })
    },
    // 清空日志
    logClear () {
      this.logEntries = []
    },
    // 按当前排序方向对日志按时间排序
    sortLogEntriesByTime () {
      var dir = this.logSortOrder === 'desc' ? -1 : 1
      this.logEntries.sort((a, b) => dir * ((Number(a.ts) || 0) - (Number(b.ts) || 0)))
    },
    // 切换排序方向后重新排列已有日志
    onLogSortOrderChange () {
      this.sortLogEntriesByTime()
      this.$nextTick(() => {
        this.scrollLogToEdge()
      })
    },
    // 超出上限时保留最新日志（升序保留末尾，降序保留开头）
    trimLogEntries () {
      if (this.logEntries.length > 2000) {
        this.logEntries = this.logSortOrder === 'desc'
          ? this.logEntries.slice(0, 1500)
          : this.logEntries.slice(-1500)
      }
    },
    // 关闭日志对话框
    closeLogDialog () {
      if (this.logSubscribed) {
        this.logUnsubscribe()
      }
      if (this.logFetchTimer) {
        clearTimeout(this.logFetchTimer)
        this.logFetchTimer = null
      }
      this.logFetching = false
      if (this.logEventSource) {
        this.logEventSource.close()
        this.logEventSource = null
      }
      this.logEntries = []
      this.logSubscribed = false
      this.logSubscribing = false
      this.stopLogCountdown()
    },
    // 启动订阅倒计时
    startLogCountdown (seconds) {
      this.stopLogCountdown()
      this.logCountdown = seconds
      this.logCountdownTimer = setInterval(() => {
        this.logCountdown--
        if (this.logCountdown <= 0) {
          this.stopLogCountdown()
          this.logSubscribed = false
          this.$notify({
            title: '订阅已到期',
            message: '日志订阅时间已到，如需继续查看请重新订阅',
            type: 'warning',
            duration: 5000
          })
        }
      }, 1000)
    },
    // 停止订阅倒计时
    stopLogCountdown () {
      if (this.logCountdownTimer) {
        clearInterval(this.logCountdownTimer)
        this.logCountdownTimer = null
      }
      this.logCountdown = 0
    },
    // 格式化倒计时显示
    formatCountdown (seconds) {
      var m = Math.floor(seconds / 60)
      var s = seconds % 60
      return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0')
    },
    // 格式化日志时间戳
    formatLogTime (ts) {
      if (!ts) return ''
      var date = new Date(ts)
      var h = String(date.getHours()).padStart(2, '0')
      var m = String(date.getMinutes()).padStart(2, '0')
      var s = String(date.getSeconds()).padStart(2, '0')
      var ms = String(date.getMilliseconds()).padStart(3, '0')
      return h + ':' + m + ':' + s + '.' + ms
    },
    // 日志级别标签
    levelLabel (level) {
      var map = { d: 'DBG', i: 'INF', w: 'WRN', e: 'ERR' }
      return map[level] || level
    },
    // 滚动到日志显示边缘：升序滚到底部（最新），降序滚到顶部（最新）
    scrollLogToEdge () {
      var el = this.$refs.logDisplay
      if (!el) return
      el.scrollTop = this.logSortOrder === 'desc' ? 0 : el.scrollHeight
    }
  }
}
</script>

<style lang="less" scoped>
/* ============================================================
 *  DeviceManagement · 运动主题设计规范 v1.0
 *  主色: #2563EB (深海蓝)  强调色: #FF6F00 (活力橙)
 * ============================================================ */

.device-page {
  /* 页面级 CSS 变量，基于全局 design-system.css */
  --aptus-primary: #2563EB;
  --aptus-primary-light: #3B82F6;
  --aptus-primary-bg: #EFF6FF;
  --aptus-accent: #FF6F00;
  --aptus-accent-bg: #FFF5EB;
  --aptus-success: #2E7D32;
  --aptus-success-bg: #EDF7ED;
  --aptus-danger: #C62828;
  --aptus-danger-bg: #FDECEC;
  --aptus-warning: #F57F17;
  --aptus-surface: #FFFFFF;
  --aptus-surface-muted: #F5F6F8;
  --aptus-border: #E2E6EC;
  --aptus-border-light: #EFF1F5;
  --aptus-text: #1A1D21;
  --aptus-text-secondary: #5E6670;
  --aptus-text-muted: #9AA3B0;

  width: 100%;
  height: calc(100vh - 88px);
  max-height: calc(100vh - 88px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.main_r {
  height: 100%;
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.page-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}

/* 页面标题 */
.title_line {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, var(--aptus-primary) 0%, var(--aptus-primary-light) 100%);
    border-radius: 2px;
  }
}

/* 统计卡片组 */
.stats-bar {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 12px;
}

.stat-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 16px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.06);
  transition: all 200ms ease;
  position: relative;
  overflow: hidden;

  /* 左侧彩色装饰条 */
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: var(--aptus-primary);
    border-radius: 8px 0 0 8px;
  }

  &:hover {
    box-shadow: 0 4px 12px rgba(15, 26, 46, 0.1);
    transform: translateY(-1px);
  }

  .stat-value {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 24px;
    font-weight: 700;
    color: var(--aptus-text);
    line-height: 1.2;
  }

  .stat-label {
    font-size: 12px;
    color: var(--aptus-text-muted);
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
}

/* 各统计卡片主题色 */
.stat-total::before { background: var(--aptus-primary); }
.stat-total .stat-value { color: var(--aptus-primary); }

.stat-online::before { background: var(--aptus-success); }
.stat-online .stat-value { color: var(--aptus-success); }

.stat-offline::before { background: var(--aptus-text-muted); }
.stat-offline .stat-value { color: var(--aptus-text-secondary); }

.stat-locked::before { background: var(--aptus-danger); }
.stat-locked .stat-value { color: var(--aptus-danger); }

/* 筛选栏 */
.filter-strip {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
}

.filter-strip__fields {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
}

.filter-field--compact {
  gap: 4px;

  /deep/ .el-input,
  /deep/ .el-select,
  /deep/ .el-date-editor {
    width: 100%;
  }
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.filter-field__label {
  font-size: 12px;
  color: var(--aptus-text-secondary);
  font-weight: 500;
  line-height: 1;
  margin-bottom: 4px;
}

.filter-strip__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  /deep/ .upload {
    margin: 0;
  }

  /deep/ .el-button {
    margin-left: 0;
  }
}

.filter-strip__sep {
  width: 1px;
  height: 24px;
  background: var(--aptus-border);
  margin: 0 2px;
}

/* 状态指示点 */
.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;

  &.is-online {
    background: var(--aptus-success);
    box-shadow: 0 0 0 3px rgba(46, 125, 50, 0.2);
  }

  &.is-offline {
    background: var(--aptus-text-muted);
  }
}

/* 在线状态文本 */
.online-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;

  &.is-online {
    color: var(--aptus-success);
    .status-dot {
      background: var(--aptus-success);
      box-shadow: 0 0 0 3px rgba(46, 125, 50, 0.2);
    }
  }

  &.is-offline {
    color: var(--aptus-text-muted);
    .status-dot {
      background: var(--aptus-text-muted);
      box-shadow: none;
    }
  }
}

/* 表格区域 */
.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 12px;
}

.table-scroll-hint {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  margin-bottom: 6px;
  font-size: 11px;
  color: var(--aptus-text-muted);
  font-weight: 500;

  i {
    font-size: 11px;
  }
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: var(--aptus-surface);
  border-radius: 8px;
  border: 1px solid var(--aptus-border);
  overflow: hidden;

  &.has-scroll::after {
    content: '';
    position: absolute;
    top: 40px;
    right: 0;
    bottom: 0;
    width: 24px;
    background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.95));
    pointer-events: none;
    z-index: 4;
  }
}

/* 设备表格 */
.device-table {
  /deep/ .col-mono {
    font-family: 'SF Mono', Monaco, 'Cascadia Code', Consolas, monospace;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.01em;
    color: var(--aptus-text-secondary);
  }

  /deep/ .el-table__body td {
    padding: 12px 0;
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__body tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ .el-table__header th {
    padding: 12px 0;
    background: var(--aptus-surface-muted) !important;
    border-bottom: 1px solid var(--aptus-border);
    color: var(--aptus-text-secondary);
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ .el-table__header th .caret-wrapper {
    flex-shrink: 0;
    margin-left: 4px;
    vertical-align: middle;
  }

  /deep/ .el-table__fixed-right-patch {
    background: var(--aptus-surface-muted);
  }

  /deep/ .el-table__fixed-header-wrapper th,
  /deep/ .el-table__fixed .el-table__fixed-header-wrapper th {
    background: var(--aptus-surface-muted) !important;
  }

  /deep/ .el-table__fixed-body-wrapper td {
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__fixed-body-wrapper tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }
}

/* 操作按钮组 */
.action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  white-space: nowrap;

  .el-link {
    font-size: 15px;
    padding: 4px 5px;
    border-radius: 5px;
    transition: all 200ms ease;
    line-height: 1;

    &:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--primary:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--danger:hover {
      background-color: var(--aptus-danger-bg);
    }

    &.el-link--warning:hover {
      background-color: var(--aptus-accent-bg);
    }

    &.el-link--success:hover {
      background-color: var(--aptus-success-bg);
    }
  }
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--aptus-border);
}

/* 响应式 */
@media (max-width: 1400px) {
  .filter-strip {
    flex-wrap: wrap;
  }

  .filter-strip__fields {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
  }

  .filter-strip__actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 1200px) {
  .stats-bar {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .device-page {
    height: calc(100vh - 72px);
  }

  .main_r {
    padding: 10px;
  }

  .stats-bar {
    grid-template-columns: 1fr 1fr;
  }

  .filter-strip__fields {
    grid-template-columns: 1fr 1fr;
  }
}

/* 通用表单 */
.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: var(--aptus-surface-muted);
}

/* 弹窗样式 */
.newAdd /deep/ .el-dialog__footer {
  padding: 16px 24px;
  text-align: right;
  border-top: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__header {
  padding: 18px 24px;
  background: var(--aptus-surface-muted);
  border-bottom: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.newAdd /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--aptus-text);
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: var(--aptus-primary);
  border-color: var(--aptus-primary);
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: var(--aptus-primary-light);
    border-color: var(--aptus-primary-light);
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--primary.is-plain {
  color: var(--aptus-primary);
  background: var(--aptus-primary-bg);
  border-color: #A8D0F5;

  &:hover {
    background: var(--aptus-primary);
    color: #FFF;
    border-color: var(--aptus-primary);
  }
}

/* ============================================================
 *  设备日志样式 · 深色终端风
 * ============================================================ */
.log-container {
  display: flex;
  flex-direction: column;
  height: 560px;
}

.log-legend {
  margin-bottom: 10px;

  /deep/ .el-alert__title {
    font-size: 12px;
    line-height: 1.7;
    font-weight: 400;
    color: var(--aptus-text-secondary);
  }

  /deep/ .el-alert {
    background: var(--aptus-primary-bg);
    border: 1px solid #A8D0F5;
  }

  /deep/ .el-alert__icon {
    color: var(--aptus-primary);
  }
}

.log-filters {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid var(--aptus-border);

  span {
    color: var(--aptus-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }
}

.log-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid var(--aptus-border);

  .log-actions-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .log-actions-divider {
    width: 1px;
    height: 28px;
    background: var(--aptus-border);
    margin: 0 16px;
  }

  .log-actions-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .action-label {
    font-size: 13px;
    color: var(--aptus-text-secondary);
    white-space: nowrap;
    font-weight: 500;
  }

  .action-unit {
    font-size: 13px;
    color: var(--aptus-text-muted);
    margin-right: 4px;
  }
}

.log-display {
  flex: 1;
  overflow-y: auto;
  background: #1a1d23;
  border-radius: 8px;
  padding: 12px;
  margin-top: 12px;
  font-family: 'SF Mono', Monaco, 'Cascadia Code', Consolas, monospace;
  font-size: 12px;
  line-height: 1.7;
  border: 1px solid #2a2e38;
}

.log-empty {
  color: #5a6070;
  text-align: center;
  padding-top: 100px;
  font-size: 13px;
}

.log-entry {
  white-space: pre-wrap;
  word-break: break-all;
  padding: 2px 0;
}

.log-time {
  color: #6a7080;
  margin-right: 8px;
}

.log-thread {
  color: #c586c0;
  margin-right: 8px;
}

.log-level-tag {
  display: inline-block;
  width: 32px;
  text-align: center;
  border-radius: 3px;
  margin-right: 6px;
  font-size: 10px;
  font-weight: 700;
}

.tag-d { color: #7a8090; background: #2a2e38; }
.tag-i { color: #4fc3f7; background: #1a3a4a; }
.tag-w { color: #ffb74d; background: #4a3a1a; }
.tag-e { color: #ef5350; background: #4a1a1a; }

.log-type-tag {
  color: #8a90a0;
  background: #2a2e38;
  padding: 0 5px;
  border-radius: 3px;
  margin-right: 6px;
  font-size: 10px;
  font-weight: 600;
}

.log-tag {
  color: #81c784;
  margin-right: 6px;
  font-weight: 500;
}

.log-msg {
  color: #c8cdd8;
}

.log-level-d { border-left: 3px solid #7a8090; padding-left: 6px; }
.log-level-i { border-left: 3px solid #4fc3f7; padding-left: 6px; }
.log-level-w { border-left: 3px solid #ffb74d; padding-left: 6px; }
.log-level-e { border-left: 3px solid #ef5350; padding-left: 6px; }

.logDialog /deep/ .el-dialog__body {
  padding: 12px 20px;
}

/* 删除确认弹窗 · 屏幕垂直居中 */
.confirmDel /deep/ .el-dialog {
  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.confirmDel /deep/ .el-dialog__body {
  padding: 20px 24px;
}

.confirmMsg {
  font-size: 15px;
  color: var(--aptus-text);
  text-align: center;
  padding: 10px 0;
}
</style>

<style lang="less">
.el-main--device-page {
  overflow: hidden;
  height: calc(100vh - 48px);
  box-sizing: border-box;
}
</style>
